// ** Redux Imports
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'

// ** Axios Imports
import API from 'api/task_types'

export const list = createAsyncThunk('appTaskTypes/list', async () => {
  return await API.listTaskTypes()
})

export const get = createAsyncThunk('appTaskTypes/get', async name => {
  return await API.getTaskType(name)
})

export const add = createAsyncThunk('appTaskTypes/add', async (instance, { dispatch }) => {
  const updated = await API.applyTaskType(instance)
  instance = {
    ...instance,
    ...updated
  }
  await dispatch(list())
  return instance
})

export const modify = createAsyncThunk('appTaskTypes/modify', async (instance, { dispatch }) => {
  const updated = await API.applyTaskType(instance)
  instance = {
    ...instance,
    ...updated
  }
  await dispatch(appTaskTypesSlice.actions.setSelected(instance))
  await dispatch(list())
})

export const del = createAsyncThunk('appTaskTypes/del', async (name, { dispatch }) => {
  await API.deleteTaskType(name)
  await dispatch(list())
  return name
})

export const appTaskTypesSlice = createSlice({
  name: 'appTaskTypes',
  initialState: {
    data: []
  },
  reducers: {
    setSelected: (state, { payload }) => {
      state.selected = payload
    }
  },
  extraReducers: builder => {
    builder
      .addCase(list.fulfilled, (state, action) => {
        state.data = action.payload
      })
      .addCase(get.fulfilled, (state, { payload }) => {
        state.selected = payload
      })
  }
})

export default appTaskTypesSlice.reducer
